module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat_popup"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chatMode === 'list'),
      expression: "chatMode === 'list'"
    }],
    staticClass: "contact-list"
  }, [_c('div', {
    staticClass: "contact-header"
  }, [_vm._v("\n      Contacts\n      "), _c('i', {
    staticClass: "el-icon-close pull-right close",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.setChatActive(false)
      }
    }
  }), _vm._v(" "), (!_vm.isMrcConsultantOrBot) ? _c('ElSwitch', {
    staticClass: "pull-right",
    attrs: {
      "value": _vm.chatStatus,
      "active-text": "On",
      "inactive-text": "Invisible",
      "active-color": "#13ce66"
    },
    on: {
      "change": _vm.chatChanged
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('ElInput', {
    attrs: {
      "placeholder": "Search...",
      "size": "mini"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (!_vm.isMrcBot) ? _c('div', {
    staticClass: "list-group-item bot",
    on: {
      "click": function($event) {
        return _vm.chatWith(_vm.bot)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o fa-2x fa-fw left-icon",
    staticStyle: {
      "color": "rgb(66, 183, 42)"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.bot.userName) + "\n      "), _c('br'), _c('span', {
    staticClass: "company-text"
  }, [_vm._v(_vm._s(_vm.bot.company))]), _vm._v(" "), _c('i', {
    staticClass: "fa float-vertical-align",
    class: _vm.chatIcon(_vm.bot.userId),
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isMrcConsultant) ? _c('div', {
    staticClass: "list-group-item consultant",
    on: {
      "click": function($event) {
        return _vm.chatWith(_vm.consultant)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o fa-2x fa-fw left-icon",
    staticStyle: {
      "color": "rgb(66, 183, 42)"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.consultant.userName) + "\n      "), _c('br'), _c('span', {
    staticClass: "company-text"
  }, [_vm._v(_vm._s(_vm.consultant.company))]), _vm._v(" "), _c('i', {
    staticClass: "fa float-vertical-align",
    class: _vm.chatIcon(_vm.consultant.userId),
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMrcConsultantOrBot || _vm.chatStatus) ? [_vm._l((_vm.onlineSortedContacts), function(c) {
    return _c('div', {
      key: c.userId,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.chatWith(c)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle-o fa-2x fa-fw left-icon",
      staticStyle: {
        "color": "rgb(66, 183, 42)"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(c.userName) + " "), _c('br'), _c('span', {
      staticClass: "company-text"
    }, [_vm._v(_vm._s(c.company || '-'))]), _vm._v(" "), _c('i', {
      staticClass: "fa float-vertical-align",
      class: _vm.chatIcon(c.userId),
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.offlineContacts), function(c) {
    return _c('div', {
      key: c.userId,
      staticClass: "list-group-item offline",
      on: {
        "click": function($event) {
          return _vm.chatWith(c)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle-o fa-2x fa-fw left-icon",
      staticStyle: {
        "color": "#c4c6c9"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(c.userName) + " "), _c('br'), _c('span', {
      staticClass: "company-text offline"
    }, [_vm._v(_vm._s(c.company || '-'))]), _vm._v(" "), _c('i', {
      staticClass: "fa float-vertical-align",
      class: _vm.chatIcon(c.userId),
      attrs: {
        "aria-hidden": "true"
      }
    })])
  })] : _vm._e()], 2), _vm._v(" "), _c('Chat', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chatMode === 'chat'),
      expression: "chatMode === 'chat'"
    }],
    ref: "chat",
    attrs: {
      "contactColor": _vm.contactColor,
      "contactTextColor": _vm.contactTextColor,
      "msges": _vm.chatUserMsges
    },
    on: {
      "back": _vm.backToChatList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2235c082","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chatbox.vue
// module id = 608
// module chunks = 34